var map = {
	"./anm-card.png": 574,
	"./app-install-icon.webp": 1678,
	"./arrow.png": 575,
	"./btn-blue-m-v2.png": 576,
	"./btn-blue-m.png": 577,
	"./btn-white-m-v2.png": 578,
	"./btn-white-m.png": 579,
	"./dummy-1.png": 580,
	"./eeziepay.svg": 581,
	"./fcl.svg": 582,
	"./fpx-logo.svg": 583,
	"./game-blue.png": 584,
	"./game-img.png": 585,
	"./game-white.png": 586,
	"./global-language.svg": 587,
	"./ifm-logo.svg": 588,
	"./logo-anniversary.png": 589,
	"./logo-christmas.png": 590,
	"./logo-cny-dragon.png": 591,
	"./logo-cny.png": 592,
	"./logo-halloween.png": 593,
	"./logo-merdeka.png": 594,
	"./logo-mooncake.png": 595,
	"./logo-raya.png": 596,
	"./logo-uefa.png": 597,
	"./merchant-logo.png": 96,
	"./modal-bg.jpg": 598,
	"./number-bg.png": 599,
	"./pagcor.svg": 600,
	"./pool-bg.png": 601,
	"./side-bar-bg.png": 602,
	"./tether.svg": 603,
	"./x33-logo-wc.png": 604,
	"./x33-logo.png": 605
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 784;